// LUMINA · pages/TermsPage.jsx
// Static terms of service page for BTF CANADA / 如意宝金刚社群

import React from 'react';
import { useNavigate } from 'react-router-dom';
import { GD, GDL, BG, TXT, TXT2 } from './vajra/constants';

const FONT = "'Noto Serif SC','Noto Serif',serif";

function SectionHeading({ zh, en }) {
  return (
    <div style={{ marginTop: 40, marginBottom: 14 }}>
      <h2 style={{ margin: 0, fontSize: 18, fontWeight: 700, color: GDL, fontFamily: FONT, letterSpacing: 1 }}>
        {zh}
      </h2>
      <div style={{ fontSize: 12, color: TXT2, marginTop: 3, fontFamily: FONT, fontStyle: 'italic' }}>
        {en}
      </div>
    </div>
  );
}

function Para({ zh, en }) {
  return (
    <div style={{ marginBottom: 16 }}>
      <p style={{ margin: 0, fontSize: 15, lineHeight: 1.85, color: TXT, fontFamily: FONT }}>
        {zh}
      </p>
      <p style={{ margin: '6px 0 0', fontSize: 13, lineHeight: 1.75, color: TXT2, fontFamily: FONT, fontStyle: 'italic' }}>
        {en}
      </p>
    </div>
  );
}

export default function TermsPage() {
  const navigate = useNavigate();

  return (
    <div style={{ minHeight: '100vh', background: BG, fontFamily: FONT, color: TXT }}>

      {/* ── Sticky Nav ── */}
      <div style={{
        position: 'sticky', top: 0, zIndex: 100,
        background: 'rgba(253,251,247,0.92)', backdropFilter: 'blur(16px)',
        borderBottom: '1px solid rgba(212,175,55,0.25)',
        padding: '0 32px', height: 56,
        display: 'flex', alignItems: 'center', justifyContent: 'space-between',
      }}>
        <button
          onClick={() => navigate('/vajra')}
          style={{ display: 'flex', alignItems: 'center', gap: 10, background: 'none', border: 'none', cursor: 'pointer', padding: 0 }}
        >
          <span style={{ color: GD, fontSize: 18 }}>☸</span>
          <div>
            <div style={{ color: GD, fontSize: 14, letterSpacing: 3, fontFamily: FONT }}>如意宝金刚社群</div>
            <div style={{ color: TXT2, fontSize: 9, letterSpacing: 2, opacity: 0.8, fontFamily: FONT }}>BTF CANADA</div>
          </div>
        </button>
        <button
          onClick={() => navigate(-1)}
          style={{
            background: 'none', border: `1.5px solid rgba(107,79,16,0.35)`,
            borderRadius: 8, color: GD, fontSize: 12,
            padding: '6px 18px', cursor: 'pointer', letterSpacing: 1, fontFamily: FONT,
          }}
        >
          返回 / Back
        </button>
      </div>

      {/* ── Content ── */}
      <div style={{ maxWidth: 800, margin: '0 auto', padding: '48px 24px 80px' }}>

        {/* Title */}
        <div style={{ borderBottom: `2px solid rgba(139,105,20,0.25)`, paddingBottom: 24, marginBottom: 8 }}>
          <h1 style={{ margin: 0, fontSize: 28, fontWeight: 700, color: GD, fontFamily: FONT, letterSpacing: 2 }}>
            服务条款
          </h1>
          <div style={{ fontSize: 16, color: TXT2, marginTop: 4, fontFamily: FONT, fontStyle: 'italic' }}>
            Terms of Service
          </div>
          <div style={{ marginTop: 14, fontSize: 13, color: TXT2, fontFamily: FONT }}>
            生效日期 / Effective date：2026年1月1日 / January 1, 2026
          </div>
          <div style={{ marginTop: 6, fontSize: 13, color: TXT2, fontFamily: FONT }}>
            发布机构：BTF CANADA（Buddhist Terma Foundation Canada · 加拿大显密文教基金会）
          </div>
        </div>

        {/* Intro */}
        <Para
          zh="欢迎使用如意宝金刚社群平台。访问或使用本平台即表示您同意遵守以下服务条款。如您不同意任何条款，请停止使用本平台。"
          en="Welcome to the BTF CANADA platform. By accessing or using this platform, you agree to be bound by these Terms of Service. If you do not agree to any term, please discontinue use of the platform."
        />

        {/* Section 1 */}
        <SectionHeading zh="1. 服务说明" en="1. Service Description" />
        <Para
          zh="如意宝金刚社群平台由BTF CANADA运营，为会员提供法会报名、修行资料、法教内容及社群交流等功能。平台内容仅供注册会员使用，部分功能需要特定修行资质或员工权限方可访问。"
          en="The BTF CANADA platform is operated by Buddhist Terma Foundation Canada and provides registered members with dharma event registration, practice resources, teaching content, and community features. Platform content is intended for registered members only; certain features require specific credentials or staff authorization."
        />

        {/* Section 2 */}
        <SectionHeading zh="2. 会员资格" en="2. Membership" />
        <Para
          zh="注册即表示您保证所提供信息真实准确，并同意妥善保管账户密码。账户为个人专用，不得转让或共享。BTF CANADA保留在合理告知后，因违反本条款或不当行为暂停或终止账户的权利。"
          en="By registering, you certify that the information you provide is accurate and complete, and you agree to maintain the confidentiality of your account credentials. Accounts are personal and non-transferable. BTF CANADA reserves the right to suspend or terminate accounts for violations of these terms or misconduct, with reasonable notice where practicable."
        />

        {/* Section 3 */}
        <SectionHeading zh="3. 禁止行为" en="3. Prohibited Conduct" />
        <Para
          zh="使用本平台时，您不得：（a）传播骚扰性、诽谤性或违法内容；（b）未经授权获取或尝试获取其他会员的账户或数据；（c）以任何方式干扰平台的正常运行；（d）将平台内容用于商业目的或在未经BTF CANADA书面许可的情况下转载传播。"
          en="When using this platform, you must not: (a) transmit harassing, defamatory, or unlawful content; (b) access or attempt to access other members' accounts or data without authorization; (c) interfere with the normal operation of the platform in any way; (d) use platform content for commercial purposes or redistribute it without prior written permission from BTF CANADA."
        />

        {/* Section 4 */}
        <SectionHeading zh="4. 内容所有权" en="4. Content Ownership" />
        <Para
          zh="平台上的所有法教内容、文字、图片及软件均属BTF CANADA或其上师授权方所有，受版权法保护。您可在个人修行范围内查阅和下载授权内容，但不得进行复制、改编或商业使用。您向平台提交的内容（如祈请文本）不得包含侵权或不当内容，提交即授予BTF CANADA在平台内展示该内容的非独家许可。"
          en="All dharma teaching content, text, images, and software on the platform belong to BTF CANADA or its licensed teachers and are protected by copyright law. You may view and download authorized content for personal practice, but may not reproduce, adapt, or use it commercially. Content you submit to the platform (such as prayer request text) must not infringe on others' rights; by submitting you grant BTF CANADA a non-exclusive licence to display it within the platform."
        />

        {/* Section 5 */}
        <SectionHeading zh="5. 责任限制" en="5. Limitation of Liability" />
        <Para
          zh="本平台按「现状」提供服务，BTF CANADA不就平台的持续可用性、无错误运行或内容的完整性作出任何明示或暗示的保证。在适用法律允许的最大范围内，BTF CANADA不对因使用或无法使用本平台而导致的任何直接、间接或附带损失承担责任。本条款不影响法律赋予您的强制性权利。"
          en="The platform is provided 'as is' without warranties of any kind, express or implied, including as to continuous availability, error-free operation, or completeness of content. To the maximum extent permitted by applicable law, BTF CANADA is not liable for any direct, indirect, or incidental damages arising from your use of or inability to use the platform. Nothing in these terms affects any mandatory rights you may have under applicable law."
        />

        {/* Section 6 */}
        <SectionHeading zh="6. 条款修改" en="6. Changes to Terms" />
        <Para
          zh="BTF CANADA保留随时修改本服务条款的权利。条款发生重大变更时，我们将通过平台通知或电子邮件提前告知会员。在通知期限届满后继续使用本平台，即视为您接受修改后的条款。建议您定期查阅本页面以了解最新条款。"
          en="BTF CANADA reserves the right to modify these Terms of Service at any time. For material changes, we will notify members in advance via platform notice or email. Continued use of the platform after the notice period constitutes acceptance of the revised terms. We encourage you to review this page periodically for the latest terms."
        />

        {/* Section 7 */}
        <SectionHeading zh="7. 缘起观察服务条款" en="7. Yuanqi Observation Service Terms" />
        <Para
          zh="缘起观察服务基于藏传佛教传统智慧体系（八字、紫微、六爻、奇门），为皈依弟子及长期学员在重要生命抉择时提供参考。"
          en="The Yuanqi Observation service draws on Tibetan Buddhist traditional wisdom systems (Bazi, Ziwei, Liuyao, Qimen) to provide reference guidance for initiated practitioners and long-term students at key decision points."
        />
        <Para
          zh="（一）性质说明：缘起观察为传统智慧参考建议，非绝对预测，亦非医疗、法律、财务专业咨询的替代品。最终抉择权在会员本人。（二）隐私保护：您的生辰信息及咨询内容仅用于生成分析报告，严格保密，不作第三方披露。（三）适用法律：本服务在加拿大安大略省提供，适用安大略省及加拿大联邦法律。"
          en="(a) Nature: Yuanqi Observation is a traditional wisdom reference, not a definitive prediction, and does not replace professional medical, legal, or financial advice. The member retains full decision-making authority. (b) Privacy: Birth information and consultation content is used solely to generate the analysis report and is kept strictly confidential; it is not disclosed to third parties. (c) Governing law: This service is provided in Ontario, Canada and is governed by Ontario and Canadian federal law."
        />

        {/* Section 8 */}
        <SectionHeading zh="8. 联系我们" en="8. Contact Us" />
        <Para
          zh="如您对本服务条款有任何疑问或意见，请通过以下方式与我们联系。"
          en="If you have any questions or comments about these Terms of Service, please contact us using the details below."
        />
        <div style={{
          marginTop: 16, padding: '20px 24px',
          background: 'rgba(139,105,20,0.06)', borderRadius: 12,
          border: '1.5px solid rgba(139,105,20,0.2)',
        }}>
          <div style={{ fontSize: 14, color: TXT, fontFamily: FONT, lineHeight: 2 }}>
            <div><strong>BTF CANADA</strong></div>
            <div>Buddhist Terma Foundation Canada · 加拿大显密文教基金会</div>
            <div>
              <span style={{ color: TXT2 }}>电子邮件 / Email：</span>
              <a href="mailto:canada.btf@gmail.com" style={{ color: GDL, textDecoration: 'none' }}>
                canada.btf@gmail.com
              </a>
            </div>
          </div>
        </div>

        {/* Footer note */}
        <p style={{ marginTop: 48, fontSize: 12, color: TXT2, fontFamily: FONT, textAlign: 'center', opacity: 0.75 }}>
          本条款如有修改，将在本页面发布更新版本，并注明生效日期。<br />
          <span style={{ fontStyle: 'italic' }}>Any updates to these terms will be posted on this page with a revised effective date.</span>
        </p>

      </div>
    </div>
  );
}
